import { defineChain } from '../../utils/chain/defineChain.js';
export const hoodi = /*#__PURE__*/ defineChain({
    id: 560048,
    name: 'Hoodi',
    nativeCurrency: { name: 'Hoodi Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.hoodi.ethpandaops.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Etherscan',
            url: 'https://hoodi.etherscan.io',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 2589,
        },
    },
    testnet: true,
});
//# sourceMappingURL=hoodi.js.map